var exports = {
  "nM": "ComparisonCheckRow.module__row___QWZLRl",
  "N4": "ComparisonCheckRow.module__feature___QWZLRl",
  "oo": "ComparisonCheckRow.module__featureText___QWZLRl",
  "a7": "ComparisonCheckRow.module__valuesContainer___QWZLRl",
  "S7": "ComparisonCheckRow.module__valueCell___QWZLRl",
  "oE": "ComparisonCheckRow.module__checkIcon___QWZLRl",
  "T7": "ComparisonCheckRow.module__dash___QWZLRl",
};

module.exports = exports;
